import { IProperty } from 'src/constants/global-interfaces';

export interface TabMeta {
  tab: Page;
  title: string;
  icon: string;
  route: string;
  visible: boolean;
  order: number;
  badge: {
    show: boolean;
    onlyDot?: boolean;
  };
}

export enum UserMode {
  Unknown = 'unknown',
  SingleUser = 'singleuser',
  MultiUser = 'multiuser',
}

export enum Page {
  SingleuserBooking = 'singleuser-booking',
  SingleuserDuties = 'singleuser-duties',
  SingleuserPinboard = 'singleuser-pinboard',
  SingleuserNews = 'singleuser-messages',
  SingleuserNewsDetails = 'singleuser-news-details',
  SingleuserReply = 'singleuser-reply',
  SingleuserMore = 'singleuser-more',
  SingleuserMonitoring = 'singleuser-monitoring',
  SingleuserOptions = 'singleuser-options',
  SingleuserRequests = 'singleuser-requests',
  SingleuserEnquiries = 'singleuser-enquiries',
  SingleuserStatistics = 'singleuser-statistics',
  SingleuserStatisticsAll = 'singleuser-statistics-all',

  MultiuserQRBooking = 'multiuser-qr-booking',
  MultiuserBooking = 'multiuser-booking',
  MultiuserPinboard = 'multiuser-pinboard',
  MultiuserMonitoring = 'multiuser-monitoring',
  MultiuserMore = 'multiuser-more',
}

export const TABS_SINGLEUSER_META: IProperty<TabMeta> = {
  [Page.SingleuserBooking]: {
    tab: Page.SingleuserBooking,
    title: 'Booking',
    icon: 'time',
    route: 'singleuser-booking',
    visible: false,
    order: 1,
    badge: {
      show: false,
    },
  },
  [Page.SingleuserDuties]: {
    tab: Page.SingleuserDuties,
    title: 'Duties',
    route: 'singleuser-duties',
    icon: 'calendar',
    visible: false,
    order: 2,
    badge: {
      show: true,
    },
  },
  [Page.SingleuserPinboard]: {
    tab: Page.SingleuserPinboard,
    title: 'Pinboard',
    route: 'singleuser-pinboard',
    icon: 'newspaper',
    visible: false,
    order: 3,
    badge: {
      show: true,
    },
  },
  [Page.SingleuserNews]: {
    tab: Page.SingleuserNews,
    title: 'News',
    route: 'singleuser-messages',
    icon: 'chatbox-ellipses',
    visible: false,
    order: 4,
    badge: {
      show: true,
    },
  },
  [Page.SingleuserMore]: {
    tab: Page.SingleuserMore,
    title: 'More',
    route: 'singleuser-more',
    icon: 'grid',
    visible: false,
    order: 5,
    badge: {
      show: true,
      onlyDot: true,
    },
  },
};

export const TABS_MULTIUSER_META: IProperty<TabMeta> = {
  [Page.MultiuserQRBooking]: {
    tab: Page.MultiuserQRBooking,
    title: 'QR_Booking',
    icon: 'qr-code',
    route: 'multiuser-qr-booking',
    visible: false,
    order: 1,
    badge: {
      show: false,
    },
  },
  [Page.MultiuserBooking]: {
    tab: Page.MultiuserBooking,
    title: 'Entry',
    route: 'multiuser-booking',
    icon: 'time',
    visible: false,
    order: 2,
    badge: {
      show: false,
    },
  },
  [Page.MultiuserPinboard]: {
    tab: Page.MultiuserPinboard,
    title: 'Pinboard',
    route: 'multiuser-pinboard',
    icon: 'newspaper',
    visible: false,
    order: 3,
    badge: {
      show: true,
    },
  },
  [Page.MultiuserMonitoring]: {
    tab: Page.MultiuserMonitoring,
    title: 'Monitoring',
    route: 'multiuser-monitoring',
    icon: 'people',
    visible: false,
    order: 4,
    badge: {
      show: true,
      onlyDot: true,
    },
  },
  [Page.MultiuserMore]: {
    tab: Page.MultiuserMore,
    title: 'More',
    route: 'multiuser-more',
    icon: 'grid',
    visible: false,
    order: 5,
    badge: {
      show: true,
      onlyDot: true,
    },
  },
};

export const TABS_UNKNOWN_META: IProperty<TabMeta> = {
  [Page.MultiuserMore]: {
    tab: Page.MultiuserMore,
    title: 'More',
    route: 'more',
    icon: 'grid',
    visible: false,
    order: 1,
    badge: {
      show: true,
      onlyDot: true,
    },
  },
};
